/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFrameSizeMaxIcon16Light = forwardRef('UiFrameSizeMaxIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.5 2.5A.5.5 0 0 1 10 2h1.5A2.5 2.5 0 0 1 14 4.5V6a.5.5 0 0 1-1 0V4.5A1.5 1.5 0 0 0 11.5 3H10a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M3 10a.5.5 0 0 0-1 0v1.5A2.5 2.5 0 0 0 4.5 14H6a.5.5 0 0 0 0-1H4.5A1.5 1.5 0 0 1 3 11.5V10Z" }),
        React.createElement("path", { d: "M14 10a.5.5 0 0 0-1 0v1.5a1.5 1.5 0 0 1-1.5 1.5H10a.5.5 0 0 0 0 1h1.5a2.5 2.5 0 0 0 2.5-2.5V10Z" }),
        React.createElement("path", { d: "M4.5 2A2.5 2.5 0 0 0 2 4.5V6a.5.5 0 0 0 1 0V4.5A1.5 1.5 0 0 1 4.5 3H6a.5.5 0 0 0 0-1H4.5Z" })));
});
